import  React, { useState , useEffect } from 'react'
import Moment from 'react-moment';
import * as momenttz from 'moment-timezone';
import { clear } from 'console';

export function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  // console.log(date, strTime);
  return strTime;
}


interface LocalTimeProps {
    timezone: string;
}

export const LocalTime = (props: LocalTimeProps) => {


    const getTime = () => {
        if (props.timezone.length > 0) {
            const localmoment = momenttz.tz(props.timezone);
            const localtime = localmoment.format('h:mm A');
            console.log(props.timezone, localtime);
            return localtime;
        }
        console.log(props.timezone, '...no timezone');
        return '';
    }

    const [tzTime,setTzTime] = useState(getTime());

    useEffect(() => {
        if (timer) {
            clearInterval(timer);
        }
        if (props.timezone.length > 0) {
            var timer = setInterval(() => setTzTime(getTime()), 1000 )
        }

        return () => {
            clearInterval(timer);
            setTzTime('');
        }

    }, [props.timezone]);

    return(
        <div className="local-time">
            {tzTime}
        </div>
    )
}

export default LocalTime;

